if (!customElements.get('gaganyaan-moon')) {
  class GaganyaanMoon extends HTMLElement {
    constructor() {
      super();
      this.image = this.querySelector('.gaganyaan-moon-image');
      if (!this.image) return;

      this.mobileStart = -95;
      this.mobileEnd = -50;
      this.desktopStart = -94;
      this.desktopEnd = -50;

      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      if (!this.image) return;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.updatePosition();
        this.ticking = false;
      });
    }

    updatePosition() {
      const rect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionTop = rect.top + window.scrollY;
      const sectionHeight = rect.height;

      const isDesktop = window.innerWidth >= 750;
      const scrollStart = sectionTop - windowHeight;
      const scrollEnd = isDesktop ? sectionTop + sectionHeight : sectionTop;
      const scrollRange = scrollEnd - scrollStart;

      const currentScroll = window.scrollY;
      const progress = Math.min(Math.max((currentScroll - scrollStart) / scrollRange, 0), 1);

      const start = isDesktop ? this.desktopStart : this.mobileStart;
      const end = isDesktop ? this.desktopEnd : this.mobileEnd;

      const marginTop = start + (end - start) * progress;
      this.image.style.marginTop = marginTop + '%';
    }
  }

  customElements.define('gaganyaan-moon', GaganyaanMoon);
}
